/* eslint-disable @typescript-eslint/no-explicit-any */
import { Close, CloudUpload } from "@mui/icons-material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import containerModal from "../../assets/styles/components/containerModal.module.css";
import modal from "../../assets/styles/components/modal.module.css";
import styles from "./DocumentUploadModal.module.css";

import { toast } from "react-toastify";
import { uploadDocumentFinanceiro } from "../../services/documentsManager";
import Button from "../Button/Button";
import SelectDocumentType from "./SelectDocumentType";

interface UploadDocumentModalProps {
  onClose: () => void;
  onSuccess?: (message: string) => void;
  refetchEntity?: any[];
  entidade:
    | "FINANCPAG"
    | "FINANCREC"
    | "EDUALUNO"
    | "RHCOLLAB"
    | "COMPRAS"
    | "FORNECEDOR"
    | "CUSTOMERS";
  uid_vinculo: string;
  initialDocType?: string;
}

const DocumentUploadModal = ({
  onClose,
  onSuccess,
  refetchEntity,
  entidade,
  uid_vinculo,
  initialDocType,
}: UploadDocumentModalProps) => {
  const queryClient = useQueryClient();
  const [selectedType, setSelectedType] = useState<string>(
    initialDocType || "",
  );
  const [uidEntidade, setUidEntidade] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      if (!file) throw new Error("Arquivo não selecionado");

      return await uploadDocumentFinanceiro(
        file,
        uidEntidade,
        selectedType,
        uid_vinculo,
      );
    },
    onSuccess: (res) => {
      onSuccess?.(res.message || "Documento enviado com sucesso!");
      queryClient.refetchQueries({
        queryKey: refetchEntity,
      });
      handleClose();
    },
    onError: (error: any) => {
      toast.error(error || "Erro ao fazer upload");
    },
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedType || !file || !uidEntidade) {
      toast.error(
        "Selecione o tipo, o arquivo e aguarde a identificação da entidade!",
      );
      return;
    }

    mutate();
  };

  const handleClose = () => {
    setSelectedType("");
    setUidEntidade("");
    setFile(null);
    onClose();
  };

  return (
    <form
      className={`${modal.containerModal} ${styles.containerProducts}`}
      onSubmit={handleSubmit}
    >
      <div className={`${containerModal.containerModal} ${styles.products}`}>
        <h1>
          {initialDocType
            ? "Atualizar Versão do Documento"
            : "Upload de Documento"}
        </h1>

        <div className={containerModal.close}>
          <Button variant="contain" typeStyle={["small", "cancel"]} onClick={handleClose} type="button">
            <Close />
          </Button>
        </div>

        <div className={styles.row}>
          <div className={styles.fieldGroup} style={{ flex: 1 }}>
            <SelectDocumentType
              entidade={entidade}
              value={selectedType}
              handleChangeDocumentType={setSelectedType}
              handleEntityFound={setUidEntidade}
            />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.fieldGroup} style={{ flex: 1 }}>
            <label className={styles.fileInputLabel}>
              <CloudUpload />
              {file ? file.name : "Selecionar o arquivo"}
              <input
                type="file"
                name="anexo"
                accept=".pdf,.rar,.zip,.xlsx,.xlsm,.xls,.jpg,.jpeg,.png,.doc,.docx"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </label>
            <small
              style={{ fontSize: "10px", marginTop: "4px", color: "#666" }}
            >
              Aceitos: PDF, RAR, ZIP, Excel, Imagens e Word.
            </small>
          </div>
        </div>

        <div className={styles.buttonSave}>
          <Button
            variant="contain"
            type="submit"
            disabled={isPending || !file || !selectedType || !uidEntidade}
          >
            {isPending ? "Enviando..." : "Enviar Documento"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default DocumentUploadModal;
